export class BoardApprovalRulesResultDto {
    rules: string;
    communityId: number;
}
